import { ETextStyleVariant, Selector } from '@outdoorsyco/bonfire';
import React from 'react';

import { EDeliveryOption } from '@/services/types/core/delivery.types';

interface IInsuranceOption {
  title: string;
  description: string;
}

interface IProps {
  name: string;
  insuranceOptions: Partial<{
    [EDeliveryOption.MOVING]: IInsuranceOption;
    [EDeliveryOption.STATIONARY]: IInsuranceOption;
  }>;
  onChange: (value: string) => void;
  onReset?: () => void;
  insuranceValue: string;
}

const InsuranceOptions: React.FC<IProps> = ({
  name,
  insuranceValue,
  insuranceOptions,
  onChange,
  onReset,
}) => {
  return (
    <>
      {Object.entries(insuranceOptions).map(
        ([key, option]) =>
          option && (
            <div className="inline-flex flex-1" key={`${option.title}-${insuranceValue}`}>
              <Selector
                label={option.title}
                ariaLabel={option.title}
                labelVariant={ETextStyleVariant.MediumBold}
                name={name}
                description={option.description}
                labelClassName="h-full"
                value={key}
                onChange={() => {
                  if (onReset && insuranceValue === key) {
                    onReset();
                  } else {
                    onChange(key);
                  }
                }}
                showIndicator
                defaultSelected={insuranceValue === key}
                data-testid={`${key}-btn`}
              />
            </div>
          ),
      )}
    </>
  );
};

export default InsuranceOptions;
